'use client';

import {useCommonData} from '@udemy-v2/common-data';
import {publishEvent} from '@udemy-v2/event-tracking';
import {useClpPurchaseContext} from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import {useClpNoticeContext} from '@/features/course-landing-page/context/clp-notice-context-provider.react-component';
import {
    PlanPeriodStyle,
    SubscribeFromPageCookie,
    SubscriptionCTA,
    SubscriptionCTAClickEvent,
    SubscriptionOfferPresented,
} from '@udemy-v2/react-subscription-browse';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import styles from './subscription-sticky-footer-cta.module.scss';

const UI_REGION = 'subscription_sticky_footer';

export const SubscriptionStickyFooterCta = () => {
    const {
        unwrappedConsumerSubscriptionPlan,
        subscriptionCTAConfiguration,
        subscriptionTiersEnabled,
    } = useClpPurchaseContext();
    const clpNoticeContext = useClpNoticeContext();
    const course = useClpCourse();
    const commonData = useCommonData();
    const subscriptionPriceBoxNotice = clpNoticeContext?.subscriptionPriceBoxNoticeData;

    const handleCtaClick = () => {
        SubscribeFromPageCookie.set('course_landing_page', parseInt(course.id, 10));

        if (subscriptionTiersEnabled && unwrappedConsumerSubscriptionPlan) {
            publishEvent(
                new SubscriptionCTAClickEvent({
                    planId: unwrappedConsumerSubscriptionPlan.id,
                    planType: unwrappedConsumerSubscriptionPlan.productType,
                    ctaType: unwrappedConsumerSubscriptionPlan.trialPeriodDays ? 'trial' : 'paid',
                    uiRegion: UI_REGION,
                    courseId: parseInt(course.id, 10),
                    planPriceIds: unwrappedConsumerSubscriptionPlan.planPriceOptionIds,
                }),
            );
        }
    };

    // With the Tiers flag enabled, we want to fire SubscriptionOfferPresented instead of SubcriptionOfferImpressionEvent as it has a productType field that lets DS differentiate between Starter Plan CLPs and Personal Plan CLPs
    const handleOfferImpression =
        subscriptionTiersEnabled && unwrappedConsumerSubscriptionPlan
            ? () => {
                  publishEvent(
                      new SubscriptionOfferPresented({
                          subscriptionPlan: unwrappedConsumerSubscriptionPlan,
                          productType: unwrappedConsumerSubscriptionPlan.productType,
                          countryCode: commonData?.user?.country ?? '',
                          courseId: parseInt(course.id, 10),
                          courseTrackingId: course.frontendTrackingId ?? null,
                          uiRegion: UI_REGION,
                      }),
                  );
              }
            : undefined;

    if (!unwrappedConsumerSubscriptionPlan) {
        return null;
    }

    return (
        <div data-testid="subscription-sticky-footer" data-purpose="subscription-sticky-footer">
            <SubscriptionCTA
                className={styles['subscription-cta']}
                uiRegion={UI_REGION}
                subtitleClassName={styles['cta-subtitle']}
                data-purpose="subscription-sticky-footer-button"
                offerCtaStyle="primary"
                onCTAClick={handleCtaClick}
                trackImpression={handleOfferImpression}
                courseId={parseInt(course.id, 10)}
                includeTrialDaysOnCta={false}
                plan={unwrappedConsumerSubscriptionPlan}
                noticeData={
                    subscriptionCTAConfiguration?.upgradeUrl
                        ? {
                              ...subscriptionPriceBoxNotice,
                              cta_1_url: subscriptionCTAConfiguration.upgradeUrl,
                          }
                        : subscriptionPriceBoxNotice
                }
                planPeriodStyle={PlanPeriodStyle.SINGLE}
                directCheckout={subscriptionCTAConfiguration?.directCheckout}
                selectPlanText={subscriptionCTAConfiguration?.selectPlanText}
                purchaseCtaText={subscriptionCTAConfiguration?.purchaseCtaText}
            />
        </div>
    );
};
